<template>
	<div>
		<Header :isHome="false"></Header>
		
		<div class="top-bg" style="padding-top: 3rem;">
			<div class="title-box">
				<img src="../../assets/imgs/export-title-icon.png" class="title-icon">
				<span class="title-text">Information center</span>
			</div>
			<div style="" class="search-box" @keydown.enter="tosearchmain(2)">
				<input type="text" style="border: none;background-color: transparent;color: #000;font-size: 1rem;width: 100%;" v-model="searchkeyword" placeholder="Search">
				<img src="../../assets/imgs/search-dark.png" style="width: 1rem;height: 1rem;cursor: pointer;" @click="tosearchmain(2)">
			</div>
		</div>
		<div class="container" v-if="data">
			<div class="news row">
				<div class="news-left col-8" v-if="data.items">
					<div class="news-top">
						<span style="cursor: pointer;" class="line-title" @click="toHome">Home</span><span class="news-top-icon">></span>
						<span>Information</span>
					</div>
					<div style="margin-top: 1rem;display: flex;align-items: center;">
						<div  class="news-title" style="flex: 1;">
							<img src="../../assets/imgs/news/news-title-bg.png" class="news-title-bg">
							Healthcare Information
						</div>
						<!-- <img src="../../assets/imgs/news/icon-more.png" class="news-more-box-img" @click="tonewslist({title:0,item:0})" style="cursor: pointer;"> -->
						<div class="button-more" style="cursor: pointer;" @click="tonewslist({title:0,item:0})">more +</div>
					</div>
					<div style="display: flex;flex-wrap: nowrap;width: 100%;overflow: scroll;" class="noscrollbar" ref="wrapper">
						<div v-for="(item, index) in list[defparams.title].item" :key="index" style="cursor: pointer;">
							<div class="btn-normal" :class="{ 'btn-normal-active': index == defparams.item }" style="cursor: pointer;width: max-content;" @click="changeitem(index, item.id)">{{item.name}}</div>
						</div>
					</div>
					<div style="display: flex;flex-direction: column;margin-top: 1rem;cursor: pointer;" @click="tonewsdetail(data.items[0].id)">
						<!-- <img :src="data.items[0].coverImage" style="border-radius: 0.625rem;"> -->
						<div :style="{backgroundImage:'url('+data.items[0].coverImage+')'}" style="background-position: center;background-repeat: no-repeat;background-size: cover;height: 22rem;
								width: 100%;border-radius: 0.625rem;"></div>
					</div>
					<div style="margin-top: 1rem;">
						<div class="news-left-box-r">
							<div class="news-left-box-r-title" style="cursor: pointer;" @click="tonewsdetail(data.items[0].id)" v-text="data.items[0].title"></div>
							<div class="news-left-box-r-tags">
								<div v-for="(tag, index1) in data.items[0].tags" :key="index1" style="margin-right: 0.5rem;" :style="{color: colorlist[index1]}" v-text="tag.name"></div>
							</div>
							
							<div style="display: flex;align-items: center;margin-top: 0.5rem;">
								<!-- <img src="../../assets/imgs/news/icon-time.png" class="news-left-box-r-icon"> -->
								<span class="news-left-box-r-icontext" v-text="format(data.items[0].createdAt)"></span>
								<img src="../../assets/imgs/news/icon-eyes.svg" class="news-left-box-r-icon">
								<span class="news-left-box-r-icontext" v-text="data.items[0].browseCount"></span>
								<img :src="data.items[0].collected?require('../../assets/imgs/news/icon-star-light.svg'):require('../../assets/imgs/news/icon-star.svg')" class="news-left-box-r-icon">
								<span class="news-left-box-r-icontext" v-text="data.items[0].collectionCount"></span>
								<img :src="data.items[0].liked?require('../../assets/imgs/news/icon-like-light.svg'):require('../../assets/imgs/news/icon-like.svg')" class="news-left-box-r-icon">
								<span class="news-left-box-r-icontext" v-text="data.items[0].likeCount"></span>
								<!-- <span class="news-left-box-r-time">News | mar.29,2023</span> -->
							</div>
						</div>
					</div>
					<div style="display: flex;flex-direction: column;margin-top: 1rem;">
						<div style="cursor: pointer;" class="news-left-box hover-up-2 transition-normal" v-for="(item, index2) in data.items.slice(1)" :key="index2" @click="tonewsdetail(item.id)">
							<div class="news-left-box-img" :style="{backgroundImage: 'url('+item.coverImage+')'}"></div>
							<div class="news-left-box-r">
								<div style="display: flex;flex-direction: column;flex: 1;">
									<div class="news-left-box-r-title text-hover" v-text="item.title"></div>
									<div class="news-left-box-r-dec" v-show="item.subTitle" v-text="item.subTitle"></div>
									<div class="news-left-box-r-tags">
										<div v-for="(tag, index3) in item.tags" :key="index3" style="margin-right: 0.5rem;" :style="{color: colorlist[index3]}" v-text="tag.name"></div>
									</div>
								</div>
							
								<div style="display: flex;align-items: center;margin-top: 0.5rem;">
									<!-- <img src="../../assets/imgs/news/icon-time.png" class="news-left-box-r-icon"> -->
									<span class="news-left-box-r-icontext" v-text="format(item.createdAt)"></span>
									<img src="../../assets/imgs/news/icon-eyes.svg" class="news-left-box-r-icon">
									<span class="news-left-box-r-icontext" v-text="item.browseCount"></span>
									<img :src="item.collected?require('../../assets/imgs/news/icon-star-light.svg'):require('../../assets/imgs/news/icon-star.svg')" class="news-left-box-r-icon">
									<span class="news-left-box-r-icontext" v-text="item.collectionCount"></span>
									<img :src="item.liked?require('../../assets/imgs/news/icon-like-light.svg'):require('../../assets/imgs/news/icon-like.svg')" class="news-left-box-r-icon">
									<span class="news-left-box-r-icontext" v-text="item.likeCount"></span>
									<!-- <span class="news-left-box-r-time">News | mar.29,2023</span> -->
								</div>
							</div>
						</div>
					</div>
					<div></div>
				</div>
				<Hotnews></Hotnews>
			</div>
			<div class="">
				<div class="">
					<div style="margin-top: 1rem;position: relative;width: 100%;" class="news-title">
						<img src="../../assets/imgs/news/news-title-bg.png" class="news-title-bg" style="top: -1.5rem;left:-0.5rem">
						Events
					</div>
					<div style="" class="row">
						<div class="col-6" style="flex-direction: column;display: flex;">
							<div class="news-more-box">
								<span style="flex: 1;"> Latest News On GCI</span>
								<!-- <img src="../../assets/imgs/news/icon-more.png" class="news-more-box-img" @click="tonewslist({title:1,item:0})" style="cursor: pointer;"> -->
								<div class="button-more" style="cursor: pointer;" @click="tonewslist({title:1,item:0})">more +</div>
							</div>
							
							<div style="display: flex;flex-direction: column;margin-top: 1rem;">
								<div style="cursor: pointer;" class="news-left-box hover-up-2 transition-normal" v-for="(item, index4) in secdata1.items" :key="index4" @click="tonewsdetail(item.id)">
									<div class="news-left-box-img" style="width: 8rem;height: 8rem;" :style="{backgroundImage: 'url('+item.coverImage+')'}"></div>
									<div class="news-left-box-r" style="width: 22rem;">
										<div class="news-left-box-r-title text-hover">{{item.title}}</div>
										<div class="news-left-box-r-tags">
											<div v-for="(tag, index5) in item.tags" :key="index5" style="margin-right: 0.5rem;" :style="{color: colorlist[index5]}">{{tag.name}} .</div>
										</div>
										<div style="display: flex;align-items: center;margin-top: 0.5rem;">
											<span class="news-left-box-r-time">{{item.createdAt | format}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-6" style="flex-direction: column;display: flex;">
							<div class="news-more-box">
								<span style="flex: 1;">Exhibitions & Forums</span>
								<!-- <img src="../../assets/imgs/news/icon-more.png" class="news-more-box-img" @click="tonewslist({title:1,item:1})" style="cursor: pointer;"> -->
								<div class="button-more" style="cursor: pointer;" @click="tonewslist({title:1,item:1})">more +</div>
							</div>
							
							<div style="display: flex;flex-direction: column;margin-top: 1rem;">
								<div style="cursor: pointer;" class="news-left-box hover-up-2 transition-normal" v-for="(item, index6) in secdata2.items" :key="index6" @click="tonewsdetail(item.id)">
									<div class="news-left-box-img" style="width: 8rem;height: 8rem;" :style="{backgroundImage: 'url('+item.coverImage+')'}"></div>
									<div class="news-left-box-r" style="width: 22rem;">
										<div class="news-left-box-r-title text-hover">{{item.title}}</div>
										<div class="news-left-box-r-tags">
											<div v-for="(tag, index7) in item.tags" :key="index7" style="margin-right: 0.5rem;" :style="{color: colorlist[index7]}">{{tag.name}} .</div>
										</div>
										<div style="display: flex;align-items: center;margin-top: 0.5rem;">
											<span class="news-left-box-r-time">{{item.createdAt|format}}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<div class="">
				<div class="">
					<div style="" class="news-more-box">
						<div style="margin-top: 1rem;position: relative;width: 100%;" class="news-title">
							<img src="../../assets/imgs/news/news-title-bg.png" class="news-title-bg" style="top: -1.5rem;left:-0.5rem">
							GCI Insights
						</div>
						<!-- <img src="../../assets/imgs/news/icon-more.png" class="news-more-box-img" @click="tonewslist({title:2,item:0})" style="cursor: pointer;"> -->
						<div class="button-more" style="cursor: pointer;" @click="tonewslist({title:2,item:0})">more +</div>
					</div>
					<div style="margin: 1rem 0;align-items: flex-start;margin-bottom: 5rem;" class="row">
						<div class="col-3 thr-box hover-up transition-normal" style="padding: 1rem;cursor: pointer;" v-for="(item, index8) in thrdata.items" :key="index8" @click="tonewsdetail(item.id)">
							<div class="thr-box-img" :style="{backgroundImage: 'url('+item.coverImage+')'}"></div>
							
							<div class="news-left-box-r" style="width: 100%;">
								<div class="news-left-box-r-title">{{item.title}}</div>
								<div class="news-left-box-r-tags">
									<div v-for="(tag, index9) in item.tags" :key="index9" style="margin-right: 0.5rem;" :style="{color: colorlist[index9]}">{{tag.name}} .</div>
								</div>
								<div style="display: flex;align-items: center;margin-top: 0.5rem;">
									<span class="news-left-box-r-time">{{item.createdAt|format}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
	
			// import axios from 'axios'
			import Header from '/src/components/header.vue'
			import Footer from '/src/components/footer.vue'
			import Hotnews from '/src/components/news/hotnews.vue'
			// import {baseUrl} from '../../assets/js/public.js'
			import Drag from '../../utils/move.js'
			export default {
				data() {
					return {
						defparams: {
							title: 0,
							item: 0,
						},
						list:[
							{
								title: 'Industry Information',
								id:1,
								item: [
									{name:'Sanitary care', id:2},
									{name:'Tourism care', id:3},
									{name:'Pet care', id:5},
									{name:'Food care', id:4},
									{name:'Home care', id:6},
								]
							},
							{
								title: 'Events',
								id:7,
								item: [
									{name:' Latest News On GCI', id:8},
									{name:'Exhibitions & Forums', id:9},
								]
							},
							{
								title: 'GCI Insights',
								id:10,
								item: []
							},
						],
						colorlist:['#01A587', '#8D66F8', '#ED532B', '#D8BE50', '#52A5F7'],
						data: [],
						page: 1,
						perPage: 10,
						
						secdata1:[],
						secdata2:[],
						
						thrdata:[],
						
						headers:{},
						islogin:false,
						searchkeyword:''
					}
				},
				props:{
				},
				components: {
					Header,
					Footer,
					Hotnews
				},
				filters: {
				},
				methods: {
					format(d){
						var date = new Date(d);
						var y = date.getFullYear();
						var m = date.getMonth() + 1;
						m = m < 10 ? ('0' + m) : m;
						var d = date.getDate();
						d = d < 10 ? ('0' + d) : d;
						var h = date.getHours();
						h = h < 10 ? ('0' + h) : h;
						var min = date.getMinutes();
						min = min < 10 ? ('0' + min) : min;
						var s = date.getSeconds();
						s = s < 10 ? ('0' + s) : s;
						return y + '-' + m + '-' + d + ' ' + h + ':' + min + ':' + s;
					},
					tosearchmain(type){
						this.$router.push({name:'searchmain', query:{type:type,keyword:this.searchkeyword}})
					},
					getData(){
						let classifyId = this.list[this.defparams.title].item.length>0?this.list[this.defparams.title].item[this.defparams.item].id:this.list[this.defparams.title].id
						// let perPage = 20, page = 1
						this.request({
							method: 'get',
							url: '/gci/article/list?classifyId=' + classifyId + '&page=1&perPage=3',
						}).then(res => {
							this.data = res.data
							this.$bus.$emit('loading', false)
							this.$nextTick(()=>{
								new Drag(this.$refs.wrapper);
							})
						}).catch(error => {
							console.error(error.response)
						})
					},
					getSecData(){
						this.request({
							method: 'get',
							url: '/gci/article/list?classifyId=' + 8 + '&page=1&perPage=3',
						}).then(res => {
							this.secdata1 = res.data
						}).catch(error => {
							console.error(error.response)
						})
						this.request({
							method: 'get',
							url: '/gci/article/list?classifyId=' + 9 + '&page=1&perPage=3',
						}).then(res => {
							this.secdata2 = res.data
						}).catch(error => {
							console.error(error.response)
						})
					},
					getThrData(){
						this.request({
							method: 'get',
							url: '/gci/article/list?classifyId=' + 10 + '&page=1&perPage=4',
						}).then(res => {
							this.thrdata = res.data
						}).catch(error => {
							console.error(error.response)
						})
					},
					changeitem(index, id){
						this.$bus.$emit('noloading', true)
						this.defparams.item = index
						this.getData()
					},
					toHome(){
						this.$router.push({name:'home'})
					},
					toNewsmain(){
						this.$router.push({name:'newsmain'})
					},
					tonewsdetail(id){
						this.$router.push({name:'newsdetail',query:{id:id,title:this.defparams.title,item:this.defparams.item}})
					},
					tonewslist(item){
						localStorage.setItem('newslist', JSON.stringify(item))
						this.$router.push('newslist')
					}
				},
				created() {
					this.$bus.$emit('loading', true)
				},
				mounted() {
					let token = localStorage.getItem('token')
					if(token){
						this.islogin = true
						this.headers = {authorization:localStorage.getItem('token')}
					}
					// this.defparams = this.$route.params
					// this.defparams = JSON.parse(localStorage.getItem('newslist'))
					// console.info(this.defparams)
					this.getData()
					this.getSecData()
					this.getThrData()
					// this.$nextTick(()=>{
					// 	new WOW().init()
					// })
				}
			}
</script>

<style scoped lang="scss">
	.line-title:hover{color: #62e0c9;}
	.thr-box{
		display: flex;flex-direction: column;align-items: center;justify-content: center;border-radius: 0.5rem;
		&-img{
			width:15rem;height: 12rem;border-radius:0.2rem;
			background-position: center center;background-size: cover;background-repeat: no-repeat;
		}
	}
	.news-more-box{
		display: flex;align-items: center;font-size: 1.2rem;font-weight: normal;
		&-img{
			width: 3rem;height: 1rem;
		}
	}
	.news{
		display: flex;
		margin-top: 2rem;
		.news-left{
			display: flex;flex-direction: column;
			.news-top{
				color: #1C1F24;
				font-size: 1rem;
				font-weight: 500;
				&-icon{
					margin: 0 0.5rem;
				}
			}
			.news-l-item{
				background-color: #fff;
				color: #333;
				font-size: 0.9rem;
				font-weight: bold;
				// padding: 0.5rem;
				border-radius: 0.2rem;
				margin-right: 1rem;
				border: 1px solid #E0E0E0;;
				margin-top: 1rem;
				display: flex;align-items: center;justify-content: center;
				// width: 6rem;
				// height: 2rem;
				padding: 0.5rem 1rem;
			}
			.news-l-item-active{
				background-color: #31ffda;color: #333;
				border:1px solid transparent
			}
		}
	}
	.news-left-box{
		background: #FFFFFF;
		// box-shadow: 0px 4px 2.5rem -2px rgba(0,0,0,0.08);
		// border: 1px solid #E2E2E2;
		border-radius: 1rem;
		padding: 1rem;
		margin-bottom: 1rem;
		display: flex;
		align-items: center;
		&-img{
			min-width: 10rem;min-height: 10rem;border-radius: 0.2rem;
			background-size: cover;background-repeat: no-repeat;background-position: center center;
		}
		&-r{
			display: flex;flex-direction: column;margin-left: 1rem;width: 100%;height: 100%;
			&-title{
				font-size: 1.2rem;
				font-weight: bold;
				color: #333;
				
				display: -webkit-box;
				-webkit-line-clamp: 2;
				-webkit-box-orient: vertical;
				text-overflow: ellipsis;
				overflow: hidden;
			}
			&-dec{
				font-size: 0.7rem;
				font-weight: 400;
				color: #666;
				margin-top: 0.5rem;
			}
			&-tags{
				font-size: 0.7rem;
				margin-top: 0.5rem;
				display: flex;
				flex-wrap: wrap;
			}
			&-icon{
				width: 1.2rem;height: 1.2rem;margin-right: 0.2rem;
			}
			&-icontext{
				font-size: 0.7rem;color: #999;margin-right: 1rem;
			}
			&-time{
				font-size: 0.7rem;
				color: #999;
				font-weight: 400;
			}
		}
	}
	.news-left-box:hover{
		box-shadow: 0px 4px 2rem -2px rgba(0,0,0,0.08);
	}
	.news-title{
		height: 3rem;
		font-size: 1.5rem;
		font-weight: bold;
		.news-title-bg{
			width: 13rem;z-index: -1;position: absolute;left: 0.5rem;top: 1rem
		}
	}
	
	.title-text{
		margin-left:-2rem
	}
	.title-box{
		display:flex;align-items: center;justify-content: center;font-weight: 900;color: #333;font-size: 3rem;
	}
	.title-icon{
		width: 3rem;height: 3rem;margin-top: 1rem;
	}
	.top-bg{
		width: 100vw;height: 20rem;display: flex;align-items: center;justify-content: center;
		background-image: url('../../assets/imgs/news-top-bg.jpg');background-size: cover;background-position: center top;background-repeat: no-repeat;
		flex-direction: column;
	}
	.search-box{
		width: 30rem;height: 3rem;background-color: #fff;margin-top: 1rem;border-radius: 5rem;padding: 0 1rem;
		display: flex;align-items: center;
	}
		.button-more{
			width: 80px;
			height: 36px;
			background: #D4F9F3;
			border-radius: 47px 47px 47px 47px;
			font-size: 0.9rem;
			font-weight: 500;
			color: #000000;
			line-height: 0px;
			
			display: flex;
			align-items: center;
			justify-content: center;
		}
		.button-more:hover{
			background: linear-gradient(270deg, #23F8D2 0%, #23F7D3 49%, #23E4EB 100%);
		}
	.noscrollbar::-webkit-scrollbar{display: none;}
	@media (max-width:767px) {
		
		.top-bg{
			height: 12rem;
			padding-top:4rem !important;
			.search-box{
				display: none;
			}
		}
		.news-title{
			font-size: 1.3rem;
		}
		.news-title-bg{
			top: 0.5rem;
		}
		.title-text{
			font-size: 2rem;
		}
		.news-left{
			max-width: 100%;
		}
		.news-left-box-img{
			width: 100% !important;
			height: 10rem !important;
		}
		.news-left-box-r-time{
			display: none;
		}
		.news-left-box-r{
			width: 100% !important;
		}
		.news-left-box{
			border: 1px solid #eee;
			flex-direction: column;
		}
		.col-6{
			min-width: 100%;
		}
		.col-3{
			min-width: 100%;
			border: 1px solid #eee;margin-bottom: 1rem;
		}
		.news-left-box-r-dec{
			display: none;
		}
		.thr-box-img{
			width:100%
		}
	}
</style>